module.exports = __webpack_public_path__ + "media/react/pages/sectioned_assignments/assets/gradcap-422b5b67e527f572dca090717d4f4236.png";